export const parseCalendarDate = (value) => {
  if (!value) return null;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return new Date(value);
};

export const formatDate = (value, options = { dateStyle: "medium" }) => {
  const date = parseCalendarDate(value);
  return date && !Number.isNaN(date.getTime()) ? date.toLocaleDateString("en-AU", options) : "-";
};

export const formatCalendarDate = formatDate;
